module.exports = __webpack_public_path__ + "202408221624/img/material_bg.b678047e.jpg";